import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import apolloClientInstance from '@apolloClientInstance';

export const apolloMutate: ApolloClient<NormalizedCacheObject>["mutate"] = async (
  options
) => {
  const apolloClient = await apolloClientInstance();
  return apolloClient.mutate(options);
};
